import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8d3dd2d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["width", "height"];
import { decode } from 'blurhash';
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BlurHash',
    props: {
        hash: {},
        width: {},
        height: {},
        imageUrl: {}
    },
    setup(__props) {
        const props = __props;
        const canvasRef = ref();
        const blurHash = ref();
        const renderBlurHash = () => {
            var _a;
            const pixels = decode((_a = props.hash) !== null && _a !== void 0 ? _a : blurHash.value, props.width, props.height);
            const canvas = canvasRef.value;
            const ctx = canvas.getContext('2d');
            const imageData = ctx.createImageData(props.width, props.height);
            imageData.data.set(pixels);
            ctx.putImageData(imageData, 0, 0);
        };
        onMounted(() => {
            if (props.hash)
                renderBlurHash();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("canvas", {
                    ref_key: "canvasRef",
                    ref: canvasRef,
                    width: _ctx.width,
                    height: _ctx.height
                }, null, 8 /* PROPS */, _hoisted_1)
            ]));
        };
    }
});
